export interface TblDecInvProyectoTesistaObjespec {
    iddecinvproyectotesistaobjespec: number,
    objespec: string,
    iddecinvproyecto: number,
    iddecinvproyectotesista: number,
}

export function VoidTblDecInvProyectoTesistaObjespec(): TblDecInvProyectoTesistaObjespec {
    return {
        iddecinvproyectotesistaobjespec: 0,
        objespec: '',
        iddecinvproyecto: 0,
        iddecinvproyectotesista: 0,
    }
}